<template>
    <div>
        <div class="container">
            <el-dialog
                title="修改管理员权限类型"
                :visible.sync="showdialog"
                width="800px"
                @close="close">
                    <el-form :model="form" ref="form" label-width="80px" :inline="false" size="normal">
                        <el-form-item label="类型名称">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="权限" size="normal">
                            <div class="p-box">
                                <div class="p-list" v-for="(item, index) in type_list" :key="index">
                                    <div class="label">{{item.name}}</div>
                                    <div class="info">
                                        <el-checkbox-group v-model="form.permission[item.name]">
                                            <el-checkbox v-for="(it, index2) in item.childrend" :key="index2" :label="it.name">
                                                {{it.name}}
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confrim">修改权限</el-button>
                            <el-button type="default" size="default" @click="showdialog = false">取消</el-button>
                        </el-form-item>
                    </el-form>
                    
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showdialog: true,
            id: '',
            form: {
                name: '',
                permission: {
                    '云招商': [],
                    '云项目': [],
                    '投资军团': [],
                    '真会投资': [],
                },
            },
            
            type_list: [
                {
                    name: '云招商',
                    childrend: [
                        {name: '项目',},{name: '户型',},{name: '经纪人',},{name: '设置',},
                    ],
                },
                {
                    name: '云项目',
                    childrend: [
                        {name: '楼盘',},{name: '户型',},{name: '楼盘置顶',},{name: '首页资讯',},{name: '用户跟进',},{name: '客户',},{name: '置业顾问',},{name: '城市',},{name: '文章',},{name: '公众号推文',},{name: '公众号',},{name: '设置',},
                    ],
                },
                {
                    name: '投资军团',
                    childrend: [
                        {name: '导师团',},{name: '活动',},{name: '问答',},{name: '问卷调查',},{name: '金融产品',},{name: '早报',},{name: '法拍房',},
                    ],
                },
                {
                    name: '真会投资',
                    childrend: [
                        {name: '成员管理',},{name: '机器人',},{name: '广告位设置',},
                    ],
                },
                {
                    name: '项目巡览',
                    childrend: [
                        {name: '项目巡览',},{name: '项目配套',},{name: '预约订单',},{name:'企业定制',},{name:'办公租赁',},{name:'企业服务',},{name:'会员福利',},{name:'会员券码',},{name:'商办资产',}
                    ],
                },
            ],
        }
    },
    mounted () {
        var id = this.$route.query.id;
        this.id = id;
        this.getAdminTypesById();
    },
    methods: {
        getAdminTypesById() {
            var params = {
                id: this.id,
            }
            this.$api.getAdminTypesById(params).then(
                data=>{
                    this.form.name = data.name;
                    this.form.permission = data.permission;
                }
            )
        },
        close() {
            this.$router.go(-1);
        },
        confrim() {
            this.$confirm('是否确定保存').then(
                confirm=>{
                    var params = {
                        id: this.id,
                        name: this.form.name,
                        permission: JSON.stringify(this.form.permission),
                    };
                    this.$api.editAdminTypesPermission(params).then(
                        data=>{
                            this.$message.success(data);
                            var obj = {
                                name: '',
                                permission: {
                                    '云招商': [],
                                    '云项目': [],
                                    '投资军团': [],
                                    '真会投资': [],
                                },
                            }
                            this.form = obj;
                            this.showdialog = false;
                        }
                    )
                },
                cancel=>{}
            )
        },
    },
}
</script>

<style lang="scss" scoped>
.base-warp{
    .head{
        .title{
            line-height: 40px;
            float: left;
        }
        .btn-box{
            float: right;
        }
    }
}
.p-box{
    .p-list{
        .label{
            color: #e6a23c;
        }
        .info{

        }
    }
}
</style>